<template>
  <div class="b-techs-list mb-80">
    <div v-if="!hideTitle" class="h4 extrabold mb-16">
      {{ dictionary.techTitle }}
    </div>

    <div class="row gx-5 gy-4">
      <div v-if="item.transmissionType" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/transmission.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techTransmissionLabel }}</span>
            <span class="h6 extrabold">{{ item.transmissionType }}</span>
          </div>
        </div>
      </div>
      <div v-if="item.fuel" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/fuel.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techFuelLabel }}</span>
            <span class="h6 extrabold">{{ item.fuel }}</span>
          </div>
        </div>
      </div>
      <div v-if="item.emissions" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/emmission.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techEmmissionsLabel }}</span>
            <span class="h6 extrabold">{{ item.emissions }} gr/Km</span>
          </div>
        </div>
      </div>
      <div v-if="item.consumption" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/consumption.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techConsumptionLabel }}</span>
            <span class="h6 extrabold">{{ item.consumption }} lt/100Km</span>
          </div>
        </div>
      </div>
      <div v-if="item.energyConsumption" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/consumption.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techEnergyConsumptionLabel }}</span>
            <span class="h6 extrabold">
              {{ item.energyConsumption }} KWh/100Km
            </span>
          </div>
        </div>
      </div>
      <div v-if="item.autonomy" class="col-md-6">
        <div class="b-tech align-items-center">
          <div>
            <LazyImage :image="{ url: '/imgs/icons/ev-autonomy.svg' }" />
          </div>
          <div>
            <span>{{ dictionary.techAutonomyLabel }}</span>
            <span class="h6 extrabold">{{ item.autonomy }}</span>
          </div>
        </div>
      </div>
      <div
        v-if="item.retailPriceBeforeTaxes && retailPriceHasValue"
        class="col-md-6">
        <div class="b-tech">
          <div class="no-image-gap"></div>
          <div>
            <span>{{ dictionary.retailPriceBeforeTaxesLabel }}</span>
            <span class="h6 extrabold">
              {{ item.retailPriceBeforeTaxes }}
            </span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import LazyImage from './../common/LazyImage.vue'
import constants from './../../../lib/constants'

export default {
  components: { LazyImage },
  props: {
    item: {
      required: true,
      type: Object,
    },
    hideTitle: {
      required: false,
      type: Boolean,
    },
  },

  computed: {
    retailPriceHasValue() {
      const retailPrice = this.item.retailPriceBeforeTaxes

      if (retailPrice === null || retailPrice === undefined) return false
      if (retailPrice.length <= 1) return false

      const priceWithoutEuroSign = retailPrice.slice(1)

      return priceWithoutEuroSign > 0
    },
    transmissionLabel() {
      let res
      const transmission = this.item.transmissionTypePreValue
      const { manual, auto } = constants.flexdrive.filters.transmissionsOptions

      switch (transmission) {
        case manual:
          res = this.dictionary.transmissionManual
          break
        case auto:
          res = this.dictionary.transmissionAutomatic
          break
        default:
          res = null
      }
      return res
    },
  },
}
</script>
<style lang="scss" scoped>
.no-image-gap {
  width: 28px;
}
</style>
